import { Dialog } from '#app/shared/ui/popups/Dialog.js'
import ContadoPopUpContent from './contadoPopupContent'

type Props = {
  setOpen: (val: boolean) => void
  open: boolean
}

export default function ContactPopUp({ open, setOpen }: Props) {
  return (
    <Dialog
      className={`!rounded-none !border-0 !border-none`}
      overlayClassName="!rounded-none !border-0 !border-none bg-transparent"
      open={open}
      onClose={() => setOpen(false)}
      hideIcon
      containerClassName="overflow-hidden !border-none"
      variant="fullscreen"
    >
      <ContadoPopUpContent setOpen={setOpen} />
    </Dialog>
  )
}
